module.exports = "<app-custom-loader [showLoader]=\"loading\"> </app-custom-loader>\n<div id=\"paypal-checkout-btn\"></div>"


//////////////////
// WEBPACK FOOTER
// /var/www/login.theprintlife.com/src/app/mnt-invoices/pay-pal-payment/pay-pal-payment.component.html
// module id = ../../../../../src/app/mnt-invoices/pay-pal-payment/pay-pal-payment.component.html
// module chunks = common